import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { QuotationRequestModel } from "@model/quotation.model";


@Injectable({
    providedIn: "root",
})
export class TuneApiService {

    constructor(private http: HttpClient) {
    }
    
    
    GetQuotation(model: QuotationRequestModel): Observable<any> {
        return this.http.post<any>("/Tune/GetQuotation",model);
    }
}
